'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Sentry = require('@sentry/react');

function _interopDefault (e) { return e && e.__esModule ? e["default"] : e; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        for (var k in e) {
            n[k] = e[k];
        }
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefault(React);
var Sentry__namespace = /*#__PURE__*/_interopNamespace(Sentry);

function setSampleRate(env, sampleRate) {
  return ['local', 'dev', 'development'].includes(env) ? 1 : sampleRate;
}

// filter integrations that use the global variable
var integrations = Sentry.getDefaultIntegrations({}).filter(function (defaultIntegration) {
  return !['BrowserApiErrors', 'Breadcrumbs', 'GlobalHandlers'].includes(defaultIntegration.name);
});
function initMstSentryScope(projectName, dsn, env, releaseVersion, pageType, prodSampleRate) {
  if (prodSampleRate === void 0) {
    prodSampleRate = 0.02;
  }
  var sampleRate = setSampleRate(env, prodSampleRate);
  var client = new Sentry.BrowserClient({
    dsn: dsn,
    transport: Sentry.makeFetchTransport,
    stackParser: Sentry.defaultStackParser,
    integrations: integrations,
    release: releaseVersion,
    environment: env,
    tracePropagationTargets: ['localhost', /^https:\/\/www.zillow\.com/, /^https:\/\/www.qa\.zillow\.net/, /^https:\/\/www.sm[1|2]\.test-automation\.zillow\.net/],
    profilesSampleRate: sampleRate,
    maxBreadcrumbs: 50,
    tracesSampleRate: sampleRate,
    sampleRate: sampleRate,
    autoSessionTracking: false
  });
  var scope = new Sentry.Scope();
  scope.setTags({
    team: 'media solutions technology',
    bundle: projectName,
    pageType: pageType
  });
  scope.setClient(client);

  // initializing has to be done after setting the client on the scope
  client.init();
  return scope;
}

var _jsxFileName = "/builds/media-solutions-technology/mst-components/mst-sentry/src/MstSentry.jsx",
  _this = undefined;
var MstSentry = function MstSentry(_ref) {
  var children = _ref.children,
    projectName = _ref.projectName,
    dsn = _ref.dsn,
    env = _ref.env,
    releaseVersion = _ref.releaseVersion,
    pageType = _ref.pageType,
    sampleRate = _ref.sampleRate,
    fallback = _ref.fallback,
    sentryScope = _ref.sentryScope;
  var scope = sentryScope !== null && sentryScope !== void 0 ? sentryScope : initMstSentryScope(projectName, dsn, env, releaseVersion, pageType, sampleRate);
  return /*#__PURE__*/React__default.createElement(Sentry__namespace.ErrorBoundary, {
    fallback: fallback,
    onError: function onError(e) {
      var _e$cause;
      return scope.captureException((_e$cause = e.cause) !== null && _e$cause !== void 0 ? _e$cause : e);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 9
    }
  }, children);
};

exports.MstSentry = MstSentry;
exports.initMstSentryScope = initMstSentryScope;
